import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import moment from "moment";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth/withWidth";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import DoneIcon from "@material-ui/icons/Done";
import MoreVertOutlinedIcon from "@material-ui/icons/MoreVertOutlined";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import InstructorSessionDelete from "./InstructorSessionDelete";
import InstructorScreenshotDialogs from "./InstructorScreenshotDialogs";
import InstructorSessionSplit from "./InstructorSessionSplit";
import InstructorSessionMerge from "./InstructorSessionMerge";

const styles = (theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  iconButton: {
    padding: 8,
  },
  drawer: (props) => ({
    width: 260,
    zIndex: 1,
  }),
});

function InstructorSessions(props) {
  const [sessionControl, setSessionControls] = React.useState({
    anchorEl: null,
    session: null,
    delete: false,
    merge: false,
    split:false,
  });

  let mobile = props.width === "sm" || props.width === "xs";

  return (
    <div>
      <Drawer
        classes={{ paper: mobile ? null : props.classes.drawer }}
        anchor="right"
        variant={mobile ? "temporary" : "persistent"}
        open={props.open}
        onClose={() => {
          props.openCtl(false);
        }}
      >
        {mobile ? null : <div className={props.classes.appBarSpacer} />}

        <List>
          {Object.values(props.sessions)
            .reverse()
            .map((session) => {
              return (
                <ListItem
                  key={session.sessionID}
                  button
                  selected={props.urlParams.sessionID === session.sessionID}
                  onClick={() => {
                    props.history.push(
                      "/instructor/" +
                        props.urlParams.courseID +
                        "/" +
                        session.sessionID
                    );
                    if (mobile) {
                      props.openCtl(false);
                    }
                  }}
                >
                  <ListItemAvatar>
                    <Avatar>{session.sessionIndex}</Avatar>
                  </ListItemAvatar>

                  <ListItemText
                    primary={"Session " + session.sessionIndex}
                    secondary={moment(session.sessionStartTime).format(
                      "ddd, MM/DD/YYYY"
                    )}
                  />

                  <ListItemSecondaryAction>
                    <IconButton
                      disabled={props.sessionActive == session.sessionID}
                      onClick={(event) => {
                        setSessionControls({
                          anchorEl: event.currentTarget,
                          session: session,
                          delete: false,
                          merge:false,
                        })
                      }}
                    >
                      <MoreVertOutlinedIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
        </List>
      </Drawer>

      <Menu
        anchorEl={sessionControl.anchorEl}
        open={sessionControl.anchorEl !== null}
        onClose={() => {
          setSessionControls({ ...sessionControl, anchorEl: null });
        }}
      >
        {(props.selRole === "instructor" || props.course?.taPrivileges?.includes("Delete Sessions")) ? <MenuItem
          button={true}
          onClick={() => {
            setSessionControls({ ...sessionControl, anchorEl: null, delete: true });
          }}
        >
          Delete session
        </MenuItem> : null}
        <MenuItem
          button={true}
          onClick={() => {
            setSessionControls({ ...sessionControl, anchorEl: null, split: true });
          }}
        >
          Split session
        </MenuItem>
        <MenuItem
          disabled={sessionControl.session ? sessionControl.session.sessionIndex == 1 : false}
          button={true}
          onClick={() => {
            setSessionControls({ ...sessionControl, anchorEl: null, merge: true });
          }}
        >
          Merge with previous session
        </MenuItem>
      </Menu>

      <InstructorSessionDelete
        key={"Delete " + sessionControl.delete}
        open={sessionControl.delete || false}
        openCtl={(open) => setSessionControls({ ...sessionControl, delete:open })}
        sessionNumber={
          sessionControl.session ? sessionControl.session.sessionIndex : ""
        }
        
        delete={() => props.deleteSession(sessionControl.session.sessionID)}
      />
      <InstructorSessionMerge
        key={"Merge " + sessionControl.merge}
        open={sessionControl.merge|| false}
        openCtl={(open) => setSessionControls({ ...sessionControl, merge:open })}
        sessionNumber={
          sessionControl.session ? sessionControl.session.sessionIndex : ""
        }
        sessionID = {sessionControl.session ? sessionControl.session.sessionID : ""}
        courseID = {props.urlParams.courseID}
        mergeSesh={(courseID, sessionID,sessionNum)=> props.mergeSesh(courseID, sessionID,sessionNum)}
        delete={() => props.deleteSession(sessionControl.session.sessionID)}
      />
       <InstructorSessionSplit
        key={"Split " + sessionControl.split}
        open={sessionControl.split || false}
        openCtl={(open) => setSessionControls({ ...sessionControl, split:open })}
        sessionNumber={
          sessionControl.session ? sessionControl.session.sessionIndex : ""
        }
        sessionID = {sessionControl.session ? sessionControl.session.sessionID : ""}
        courseID = {props.urlParams.courseID}
        delete={() => props.deleteSession(sessionControl.session.sessionID)}
      />
      <InstructorScreenshotDialogs 
        openNoDeviceDialog={props.openNoDeviceDialog}
        openNoAccessDialog={props.openNoAccessDialog}
        openNoDeviceDialogCtl={(open)=> {
          props.openNoDeviceDialogCtl(open);
        }}
        openNoAccessDialogCtl={(open)=> {
          props.openNoAccessDialogCtl(open);
        }}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {selRole: state.selRole};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(InstructorSessions))
  )
);
